const MUSTER = /^[a-z0-9_]{1,48}$/;
const ERSATZ: Record<string, string> = { ä: "ae", ö: "oe", ü: "ue", ß: "ss" };

export function istGueltigerSchluessel(s: string): boolean {
  return MUSTER.test(s);
}

export function schluesselFehler(s: string): string | null {
  return istGueltigerSchluessel(s) ? null : "Nur Kleinbuchstaben, Ziffern und _ erlaubt, höchstens 48 Zeichen.";
}

export function schluesselVorschlag(name: string): string {
  return name
    .toLowerCase()
    .replace(/[äöüß]/g, (z) => ERSATZ[z] ?? z)
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 48)
    .replace(/_+$/, "");
}
